// src/components/Contact.js
import { FaGithub, FaLinkedin, FaEnvelope, FaWhatsapp } from "react-icons/fa";
import { useEffect, useRef } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const socials = [
  {
    icon: FaWhatsapp,
    href: "https://wa.me/918860131912",
    label: "WhatsApp",
    hover: "hover:bg-green-600 hover:text-white",
  },
  {
    icon: FaGithub,
    href: "https://github.com/mohdsazidkhan",
    label: "GitHub",
    hover: "hover:bg-gray-900 hover:text-white",
  },
  {
    icon: FaLinkedin,
    href: "https://linkedin.com/in/mohdsazidkhan",
    label: "LinkedIn",
    hover: "hover:bg-blue-700 hover:text-white",
  },
  {
    icon: FaEnvelope,
    href: "mailto:support@mohdsazidkhan.com",
    label: "Email",
    hover: "hover:bg-red-600 hover:text-white",
  },
];

export default function Contact() {
  const ref = useRef();

  useEffect(() => {
    gsap.fromTo(
      ref.current,
      { y: 60, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1,
        scrollTrigger: {
          trigger: ref.current,
          start: "top 80%",
        },
      }
    );
  }, []);

  return (
    <section
      id="contact"
      ref={ref}
      className="relative min-h-screen py-20 px-6 bg-white border-t border-gray-200 overflow-hidden flex items-center"
    >
      <div className="pointer-events-none absolute top-0 right-1/4 w-72 h-72 bg-rose-100/60 rounded-full blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 left-0 w-64 h-64 bg-pink-100/60 rounded-full blur-3xl" />

      <div className="relative z-10 max-w-xl mx-auto text-center w-full bg-gray-50 border border-gray-100 rounded-3xl shadow-xl px-6 py-10 md:px-10 md:py-14">
        <span className="inline-block text-xs md:text-sm font-semibold tracking-widest uppercase text-red-700 bg-white px-4 py-1.5 rounded-full shadow-sm mb-5">
          Let's talk
        </span>
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
          Let's Connect
        </h2>
        <p className="mb-8 text-base md:text-lg text-gray-700">
          Reach out to me anytime on the platforms below 👇
        </p>

        <div className="flex justify-center flex-wrap gap-5 md:gap-6">
          {socials.map(({ icon: Icon, href, label, hover }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noreferrer"
              aria-label={label}
              className="group flex flex-col items-center gap-2"
            >
              <span
                className={`w-14 h-14 flex items-center justify-center rounded-full bg-white text-2xl text-gray-800 shadow-md transition-all duration-300 group-hover:scale-110 group-hover:shadow-lg ${hover}`}
              >
                <Icon />
              </span>
              <span className="text-xs font-medium text-gray-600">{label}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
